import { render } from "./PublicCatalogue.vue?vue&type=template&id=39b152cd&scoped=true"
import script from "./PublicCatalogue.vue?vue&type=script&lang=js"
export * from "./PublicCatalogue.vue?vue&type=script&lang=js"

import "./PublicCatalogue.vue?vue&type=style&index=0&id=39b152cd&scoped=true&lang=css"

import exportComponent from "/Volumes/Storage/Development/VintageTradingPost/chicken-auction-system/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b152cd"]])

export default __exports__